const ORDINAL_O_PATH =
  "M23.3846 15H30.5117V19.8611H24.8615C23.3846 19.8611 22.6462 20.5556 22.6462 21.9444V33.0556C22.6462 33.2673 22.6633 33.4629 22.6976 33.6424V39.9865C20.4637 39.8967 18.8096 39.3572 17.7354 38.3681C16.5785 37.2569 16 35.4861 16 33.0556V21.9444C16 19.5139 16.5785 17.7546 17.7354 16.6667C18.9169 15.5556 20.8 15 23.3846 15ZM26.0465 40H32.6154C35.2 40 37.0708 39.456 38.2277 38.3681C39.4092 37.2569 40 35.4861 40 33.0556V21.9444C40 19.5139 39.4092 17.7546 38.2277 16.6667C37.2656 15.7427 35.8099 15.2029 33.8605 15.0473V35.1089H31.6384C31.4824 35.1289 31.3157 35.1389 31.1385 35.1389H26.0465V40Z";

interface OrdinalIconProps {
  className?: string;
  width?: number | string;
  height?: number | string;
  fill?: string;
}

export const OrdinalIcon: React.FC<OrdinalIconProps> = ({
  className,
  width = 55,
  height = 55,
  fill = "currentColor"
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 55 55"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx="27.5" cy="27.5" r="25.5" fill={fill}stroke="white" strokeWidth="4" />
      <path fillRule="evenodd" clipRule="evenodd" d={ORDINAL_O_PATH} fill="url(#paint0_linear_4_1161)" />
      <title>Ordinal Icon</title>
      <defs>
        <linearGradient id="paint0_linear_4_1161" x1="28" y1="15" x2="28" y2="40" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FFBB61" />
          <stop offset="1" stopColor="#FFCD8A" />
        </linearGradient>
      </defs>
    </svg>
  );
};

/** Logomark-only variant (no background circle). Used in loading states. */
export function OrdinalIconSimple({ className }: { className?: string }) {
  return (
    <svg viewBox="16 15 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path fillRule="evenodd" clipRule="evenodd" d={ORDINAL_O_PATH} fill="url(#ordinal-gradient-loading)" />
      <defs>
        <linearGradient id="ordinal-gradient-loading" x1="28" y1="15" x2="28" y2="40" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FFBB61" />
          <stop offset="1" stopColor="#FFCD8A" />
        </linearGradient>
      </defs>
    </svg>
  );
}